import { GET_FORMS, SET_FORMS, SET_NEW_FORMS_NUMBER } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false,
  newForms: 0,
};

const formsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORMS:
      return { ...state, isLoading: true };
    case SET_FORMS:
      return {
        ...state,
        list: action.forms,
        isLoaded: true,
        isLoading: false
      };
    case SET_NEW_FORMS_NUMBER:
      return {
        ...state,
        newForms: action.number || 0,
      }
    default:
      return state;
  }
};

export default formsReducer;
